import React from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { INCOME_FREQUENCY_OPTIONS } from "../../../../constants/options";
import Select from "@components/select";
import { usePendingPrefill, useSetDefaultValue } from "@hooks";

// todo: see if all Select/Input elements can follow this practice of flex-ending
const FlexContentsEnd = styled.div`
  .select-Component {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`;

export default function IncomeFrequency() {
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  
  const name = "incomeFrequency";
  const value = values[name];
  
  useSetDefaultValue(name, INCOME_FREQUENCY_OPTIONS[0].value);
  usePendingPrefill(name);

  return (
    <FlexContentsEnd>
      <Select
        title="Income frequency"
        toolTipText="How often do you receive your main source of income?"
        options={INCOME_FREQUENCY_OPTIONS}

        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
        name={name}
        errorMessage={touched[name] ? errors[name] : ""}
      />
    </FlexContentsEnd>
  );
}
